"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationSelection = void 0;
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./IntegrationSelection.css"));
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var lodash_1 = require("lodash");
var IntegrationSelection = function (props) {
    var automationsMetadata = props.automationsMetadata, selectedTarget = props.selectedTarget, onIntegrationSelection = props.onIntegrationSelection;
    var Icon = (selectedTarget.integrationName && icons[(0, lodash_1.capitalize)(selectedTarget.integrationName)]) || icons.Tokens;
    var automationsList = [];
    automationsMetadata.map(function (automation) {
        if (automation.supportedObjects.length > 0) {
            automation.supportedObjects.forEach(function (object) {
                automationsList.push({
                    displayName: automation.displayName,
                    integrationName: automation.integrationName,
                    objectType: object.name,
                    objectDisplayName: object.pluralName,
                    enabled: automation.enabled,
                    canBeGloballyAssigned: automation.canBeGloballyAssigned,
                });
            });
        }
        else {
            automationsList.push({
                displayName: automation.displayName,
                integrationName: automation.integrationName,
                enabled: automation.enabled,
                canBeGloballyAssigned: automation.canBeGloballyAssigned,
            });
        }
    });
    return (react_1.default.createElement(kaleidoscope_1.Stack, { padding: "m", gap: "s", className: styles.wrapper },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Apps"),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
            react_1.default.createElement(kaleidoscope_1.Card, { className: styles.qwilr },
                react_1.default.createElement(icons_1.Qwilr, null),
                react_1.default.createElement(kaleidoscope_1.Text, null, "Qwilr")),
            react_1.default.createElement(icons_1.ArrowRight, { className: styles.arrowRight, size: icons_1.IconSize.Large }),
            react_1.default.createElement(kaleidoscope_1.Select, { className: styles.integrationDropdown, label: "Select an integration", labelHidden: true, placeholder: "Select an integration", value: selectedTarget.integrationName, autoStack: true, onChange: lodash_1.noop, icon: react_1.default.createElement(Icon, null) }, automationsList.map(function (integration, index) {
                var Icon = (integration.integrationName && icons[(0, lodash_1.capitalize)(integration.integrationName)]) || icons.Tokens;
                return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: index, value: integration.integrationName, icon: react_1.default.createElement(Icon, null), onClick: function () { return onIntegrationSelection(integration); } }, integration.objectDisplayName
                    ? "".concat(integration.displayName, " (").concat(integration.objectDisplayName, ")")
                    : integration.displayName));
            })))));
};
exports.IntegrationSelection = IntegrationSelection;
